export default __webpack_public_path__ + "static/media/logo_png.b6c5be09.png";